import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
});

// Folders API
export const foldersAPI = {
  list: (parentId = null) => {
    const params = parentId ? { parent: parentId } : { parent: 'null' };
    return api.get('/folders/', { params });
  },
  create: (data) => api.post('/folders/', data),
  get: (id) => api.get(`/folders/${id}/`),
  update: (id, data) => api.patch(`/folders/${id}/`, data),
  delete: (id) => api.delete(`/folders/${id}/`),
  tree: (id) => api.get(`/folders/${id}/tree/`),
  treeAll: () => api.get('/folders/tree_all/'),
};

// Files API
export const filesAPI = {
  list: ({ folderId = null, page = 1, pageSize = 50, search = '', ordering = '-created_at', signal } = {}) => {
    const params = {
      page,
      page_size: pageSize,
      ordering,
    };
    if (search) params.search = search;
    if (folderId) {
      params.folder = folderId;
    } else {
      params.folder = 'null';
    }
    return api.get('/files/', { params, signal });
  },
  upload: (formData, { onUploadProgress, signal } = {}) => {
    return api.post('/files/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: [(data) => data],
      onUploadProgress,
      signal,
    });
  },
  get: (id) => api.get(`/files/${id}/`),
  update: (id, data) => api.patch(`/files/${id}/`, data),
  delete: (id) => api.delete(`/files/${id}/`),
  download: (id) => api.get(`/files/${id}/download/`),
  move: (id, folderId) => api.post(`/files/${id}/move/`, { folder: folderId }),
  rename: (id, name) => api.post(`/files/${id}/rename/`, { name }),
  bulkDelete: (ids) => api.post('/files/bulk-delete/', { ids }),
  bulkMove: (ids, folderId) => api.post('/files/bulk-move/', { ids, folder: folderId }),
  exportLinks: ({ ids, folderId } = {}) => {
    const body = {};
    if (ids && ids.length) body.ids = ids;
    else body.folder_id = folderId === undefined ? null : folderId;
    return api.post('/files/export-links/', body);
  },
  markQrDownloaded: (id) => api.post(`/files/${id}/mark-qr-downloaded/`),
  qrcode: (id) => `${API_BASE_URL}/files/${id}/qrcode/`,
};

export default api;
